/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
    Autocomplete,
    Card,
    Grid,
    TextField,
    Button,
    InputAdornment,
    IconButton,
    Box,
    Modal,
    Typography,

} from "@mui/material";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import axios from "axios";
import PickDate from "components/DatePicker/DatePicker";
import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { addExpensesData, getCurrencyCode, getExpensesById, updateExpenseData } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import PageTitle from "examples/PageTitle/PageTitle";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import ShowProfile from "components/ShowProfileModal/ShowProfileModal";
import { formatNumberWithCommas } from "utils/formatCurrency";

const errMsg = {
    color: `red`,
    fontSize: `11px`,
};
const pdfStyle = {
    boxShadow: 24,
    p: 4,
    top: "50%",
    left: "50%",
    width: "90%",
    height: "90%x",
    position: "absolute",
    border: "2px solid #000",
    bgcolor: "background.paper",
    transform: "translate(-50%, -50%)",
};
let SCREEN_RIGHT;
let fetchedExpense;
let routePath = "/expenses";
function AddExpenses() {
    const { id } = useParams();
    const [controller] = useMaterialUIController();
    const { darkMode, sidenavColor } = controller;

    const [screenName, setScreenName] = useState("Add New Expenses");
    const [loading, setLoading] = useState(false);
    const [disableColor, setDisableColor] = useState(false);
    const [totalAmountErr, setTotalAmountErr] = useState(false);
    const [taxAmountErr, setTaxAmountErr] = useState(false);
    const [taxAmountErrMsg, setTaxAmountErrMsg] = useState(false);
    const [nameErr, setNameErr] = useState(false);
    const [categoryNameErr, setCategoryNameErr] = useState(false);
    const navigate = useNavigate();
    const [itemCategoriesName, setItemCategoriesName] = useState([]);
    const [contactSupplierName, setContactSupplierName] = useState([]);
    const dispatch = useDispatch()

    const datePickerRef = useRef(null);
    const nextFieldRef = useRef(null);

    const [currencyCode, setCurrencyCode] = useState("");
    const [values, setValues] = useState({
        categoryCodeName: "",
        categoryID: "",
        contactTypeId: "",
        name: "",
        expenseDate: new Date(),
        totalAmount: "",
        taxAmount: "",
        tipAmount: "",
        referenceNumber: "",
        notes: "",
        uploadDocument: "",
        businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,
        searchParameterList: ['categoryCodeName', 'name', 'expenseDate', 'totalAmount', 'taxAmount', 'tipAmount', 'categoryNameID', 'contactTypeId'],
    });

    const [file, setFile] = useState();
    const [actualFile, setActualFile] = useState();
    const [fileName, setFileName] = useState("");
    const [showEYEBtn, setShowEYEBtn] = useState(false);
    const [showImageFlag, setShowImageFlag] = useState(false);


    useEffect(() => {

        if (datePickerRef.current) {
            datePickerRef.current.querySelector('input').focus();
        }
    }, []);

    useEffect(() => {
        id === undefined ? setScreenName("Add New Expense") : setScreenName("Edit Expense");
        (async () => {
            fetchCategories();
            fetchCurrencyValue();
            fetchSupplier();
            getRight();
            if (id !== undefined) {
                values._id = id
                getExpensesById({ _id: id }, (data) => {
                    if (data.Result_Output.length > 0) {
                        fetchedExpense = data.Result_Output[0];
                        setValues(fetchedExpense);
                        if (fetchedExpense.uploadDocument) {
                            console.log("garaf", fetchedExpense.uploadDocument)
                            setShowEYEBtn(true);
                            setFileName(fetchedExpense.uploadDocument);
                            setFile(appConstants.baseURL + "expenses/viewDocument?fileName=" + fetchedExpense.uploadDocument);
                        }
                    }
                }, dispatch)
            }
        }
        )();
    }, [dispatch])

    useEffect(() => {
        const contactFromUrl = new URLSearchParams(window.location.search).get('contact');
        if (contactFromUrl) {
            if (contactFromUrl === 'add-new') {
                handleContactChange('name')('', { label: 'Add New Supplier ', value: 'add-new' });
            } else {
                const selectedContact = contactSupplierName.find(contact => contact._id === contactFromUrl);
                if (selectedContact) {
                    handleContactChange('name')('', { label: selectedContact.companyName, value: contactFromUrl });
                }
            }
        }
    }, [contactSupplierName]);
    let fetchCurrencyValue = async () => {
        values.businessUserID && await getCurrencyCode({ businessUserID: values.businessUserID }, (data => {
            if (data.Result_Status) {
                setCurrencyCode(data.Result_Output)
            }
        }), dispatch);
    }

    async function getRight() {
        let right = await getScreenRight("Items")
        if (right === "Full Access") {
            setDisableColor(false)
        }
        else setDisableColor(true)
    }

    let fetchSupplier = async () => {
        await axios
            .post(appConstants.baseURL + "expenses/ContactData", { businessUserID: values.businessUserID })
            .then(
                (res) => {
                    let response = res.data.fetchContactType;
                    setContactSupplierName(response);
                }
            )
            .catch(
                (error) => {
                    console.log("Error in Fetching" + JSON.stringify(error))
                    setLoading(false); console.log(error)
                }
            )
    }

    let fetchCategories = async () => {

        await axios
            .post(appConstants.baseURL + "items/fetchCategoriesData", { businessUserID: values.businessUserID })
            .then(
                (res) => {
                    let response = res.data.fetchCategories;
                    setItemCategoriesName(response);
                }
            )
            .catch(
                (error) => {
                    console.log("Error in Fetching", error.message)

                }
            )
    }



    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            nextFieldRef.current.focus();
        }
    };


    const handleNewChange = (name) => (event, newValue) => {
        if (newValue && newValue.value === 'add-new') {
            // Redirect to the new page when "Add New" is selected

            navigate("/itemCategory/addItemCategory?new=expense")
        } else {
            if (newValue) {
                setValues({ ...values, [name]: newValue.label, categoryID: newValue.value });
            } else {
                setValues({ ...values, [name]: '', categoryID: '' });
            }
        }
    };
    const handleContactChange = (name) => (event, newValue) => {
        if (newValue && newValue.value === 'add-new') {
            // Redirect to the new page when "Add New" is selected
            navigate("/contacts/addContact?new=expense")
        } else {
            if (newValue) {
                setValues({ ...values, [name]: newValue.label, contactTypeId: newValue.value });
            } else {
                setValues({ ...values, [name]: '', contactTypeId: '' });
            }
        }
    };

    const handleChange = (name) => (event) => {




        if (name === 'totalAmount' || name === 'taxAmount') {

            let value = event.target.value.replace(/,/g, ""); // remove commas for validation

            // allow typing "." at start
            if (value === ".") value = "0.";

            // allow empty value (so user can erase)
            if (value === "") {
                setValues({ ...values, [name]: "" });
                return;
            }

            // validate up to 2 decimals, max 7 digits before decimal
            const regex = /^\d{0,7}(\.\d{0,2})?$/;
            if (regex.test(value)) {
                setValues({ ...values, [name]: value });
            }
            // let value = event.target.value;
            // if (value === ".") {
            //     value = "0."
            // }
            // const regex = /^\d{1,7}(?:\.\d{0,2})?$/;
            // if (regex.test(value) || value === "") {
            //     setValues({ ...values, [name]: value });
            // }
        }

        else if (event.target.validity !== undefined && event.target.validity.valid === true) {
            setValues({ ...values, [name]: event.target.value });
        }
        else if (event.target.validity === undefined) {
            setValues({ ...values, [name]: event.target.value });
        }
        console.log("asdsadsa", event.target.value)
    };


    const clearErrorStates = () => {

        setTotalAmountErr(false);
        setTaxAmountErr(false);
        setCategoryNameErr(false);
        setNameErr(false);
        setTaxAmountErrMsg("");
        // setTipAmountErrMsg("");
    };

    const handleAddData = async () => {
        let mandateFlag = false;
        clearErrorStates();
        mandateFlag = validateField(values.totalAmount, setTotalAmountErr) || mandateFlag;
        mandateFlag = validateField(values.taxAmount, setTaxAmountErr) || mandateFlag;

        mandateFlag = validateField(values.name, setNameErr) || mandateFlag;
        mandateFlag = validateField(values.categoryCodeName, setCategoryNameErr) || mandateFlag;
        if (parseFloat(values.totalAmount) <= parseFloat(values.taxAmount)) {
            showResMsg("Tax Amount can't be greater than or equal to Total Amount", 2000, false);
            return mandateFlag = true;
        }
        if (parseFloat(values.totalAmount) < parseFloat(values.tipAmount)) {
            showResMsg("Tip Amount can't be greater than Tax Amount", 2000, false)
            return mandateFlag = true;
        }
        if (mandateFlag) {
            return;
        }
        const formData = new FormData();
        const arrayOfObjects = Object.entries(values).map(([key, value]) => ({ key, value }));
        for (const val of arrayOfObjects) {
            if (val.value) {
                formData.append(val.key, val.value);
            }
        }
        if (actualFile && fileName !== undefined && actualFile && fileName !== "") {
            formData.append('file', actualFile);
            formData.append("fileName", fileName);
        }
        const apiFunction = id === undefined ? addExpensesData : updateExpenseData;

        apiFunction(formData, (data) => {
            if (data.Result_Status) {
                showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
            } else {
                showResMsg(data.Result_Message, 2000, data.Result_Status);
            }
        }, dispatch);
    };

    const handleCancel = (index) => {
        ShowSwalWithButtons(
            'Are you sure?',
            `Would you like to exit from this ${id
                ? "Edit Expense"
                : "Add New Expense"
            }?`,
            'warning',
            darkMode,
            () => {
                let routePath = '/expenses'; // default
                navigate(routePath); // ✅ redirect user
            }
        );
    };

    const handleDateChange = (date) => {
        values.expenseDate = new Date(date)
        setValues({ ...values, expenseDate: values.expenseDate })
    };

    const saveFile = (e) => {
        try {
            const fileInput = e.target;
            const file = fileInput.files[0];
            if (file) {
                let fileSizeInMB = file.size / (1024 * 1024);
                if (fileSizeInMB > 1) {
                    showResMsg(`File can't be blank or more than 1 MB`, 2000, false);
                } else {
                    // setOpenCropImageModal(true);
                    setFile(URL.createObjectURL(file));
                    setActualFile(file);
                    setFileName(file.name);
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        setShowImageFlag(false);
                        setShowEYEBtn(true);
                    };
                    reader.readAsDataURL(file);
                }
            } else {
                // Handle the case when no file is selected
                setFile(null);
                setActualFile(null);
                setFileName('');
                setShowEYEBtn(false);
            }
            // Reset the file input value to allow re-selection of the same file
            fileInput.value = null;
        } catch (error) {
            console.log("Catch in saveFile=", error);
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div style={{ marginTop: "20px" }}>

                <Card sx={{ boxShadow: "none" }}>
                    <PageTitle screenName={screenName} />
                    <MDBox mt={6} mb={3}>
                        <Grid container spacing={1} style={{ display: "flex", justifyContent: "center" }}>
                            <Grid item lg={12} xs={12}>

                                <MDBox>

                                    <Grid container px={2} py={2} spacing={3}>
                                        <Grid item lg={4} xs={12} >
                                            <PickDate
                                                selected={new Date(values.expenseDate)}
                                                onChange={handleDateChange}
                                                label="Expense Date"
                                                maxDate={new Date()}
                                                onKeyUp={handleKeyPress}
                                            />
                                        </Grid>
                                        <Grid item lg={4} xs={12}>
                                            <Autocomplete
                                                sx={{ height: "44.11px" }}
                                                labelId="contactName-select-label"
                                                id="contactName-select"
                                                options={[
                                                    { label: 'Add New Supplier', value: 'add-new' },
                                                    ...contactSupplierName.map(contact => ({
                                                        label: contact.companyName,
                                                        value: contact._id
                                                    }))
                                                ]}
                                                renderOption={(props, option) => (
                                                    <li {...props}
                                                        // className={option.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteList'}
                                                        className={

                                                            darkMode ? `${option.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteDarkList'}` : `${option.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteList'}`
                                                        }

                                                    >
                                                        {option.label}
                                                    </li>
                                                )}
                                                filterOptions={(options, state) => {
                                                    const filtered = options.filter(option =>
                                                        option.label.toLowerCase().includes(state.inputValue.toLowerCase())
                                                    );
                                                    if (!filtered.some(option => option.value === 'add-new')) {
                                                        filtered.unshift({ label: 'Add New', value: 'add-new' }); // Ensure 'Add New' is always in the filtered list
                                                    }
                                                    return filtered;
                                                }}
                                                onChange={handleContactChange("name")}
                                                value={values.name}
                                                renderInput={(params) =>
                                                    <TextField {...params} label="Supplier Name" size="medium"
                                                        inputRef={nextFieldRef} placeholder="Supplier Name"
                                                        className="ress"
                                                        sx={{ paddingBottom: '6px' }}
                                                    />}
                                                disabled={id}
                                            />
                                            {nameErr ? <span style={errMsg}>Supplier Name  can't be blank</span> : ""}
                                        </Grid>

                                        {/* <Grid item lg={0.5} pt={1} mr={0.1} style={{ position: "relative", right: "5px" }} className="addItem">

                                            {!id ?
                                                <TimelineItem
                                                    color="info"
                                                    icon="add"
                                                    title="Add New Supplier"
                                                    height="2rem"
                                                    width="2rem"
                                                    fontSize="small"
                                                    style={{ paddingLeft: "220px" }}
                                                    onClick={() => { navigate("/contacts/addContact?new=expense") }}
                                                />
                                                :
                                                <TimelineItem
                                                    color="grey"
                                                    icon="add"
                                                    title="Add New Contact"
                                                    height="2rem"
                                                    width="2rem"
                                                    fontSize="small"
                                                />}


                                        </Grid> */}
                                        <Grid item lg={4} xs={12}>
                                            <Autocomplete
                                                sx={{ height: "44.11px" }}
                                                labelId="contactName-select-label"

                                                id="contactName-select"
                                                options={[
                                                    // { label: "Add New Account", value: 'add-new' },
                                                    ...itemCategoriesName.map(category => ({
                                                        label: category.categoryCodeName,
                                                        value: category._id
                                                    }))
                                                ]}
                                                renderOption={(props, option) => (
                                                    <li {...props}
                                                        // className={option.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteList'}
                                                        // className={
                                                        //     darkMode ? `${option.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteDarkList'}` : `${option.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteList'}`
                                                        // }
                                                        className={
                                                            darkMode ? `autoCompleteDarkList` : `autoCompleteList`
                                                        }
                                                    >
                                                        {option.label}
                                                    </li>
                                                )}
                                                // filterOptions={(options, state) => {
                                                //     const filtered = options.filter(option =>
                                                //         option.label.toLowerCase().includes(state.inputValue.toLowerCase())
                                                //     );
                                                //     // if (!filtered.some(option => option.value === 'add-new')) {
                                                //     //     filtered.unshift({ label: 'Add New', value: 'add-new' }); // Ensure 'Add New' is always in the filtered list
                                                //     // }
                                                //     return filtered;
                                                // }}
                                                onChange={handleNewChange("categoryCodeName")}
                                                value={values.categoryCodeName}
                                                renderInput={(params) => <TextField {...params} className="ress" label="Account" placeholder="Account List" sx={{ paddingBottom: '6px' }} size="medium" />}
                                                disabled={id}
                                            />
                                            {categoryNameErr ? <span style={errMsg}>Account Name can't be blank</span> : ""}
                                        </Grid>
                                        {/* <Grid item lg={0.4} pt={0.5} style={{ position: "relative", right: "3px" }} className="addItem1">


                                            {!id ?
                                                <TimelineItem
                                                    color="info"
                                                    icon="add"
                                                    title="Add New Category"
                                                    height="2rem"
                                                    width="2rem"
                                                    fontSize="small"
                                                    style={{ paddingLeft: "220px" }}
                                                    onClick={() => { navigate("/addItemCategory?new=expense") }}
                                                />
                                                :
                                                <TimelineItem
                                                    color="grey"
                                                    icon="add"
                                                    title="Add New Category"
                                                    height="2rem"
                                                    width="2rem"
                                                    fontSize="small"
                                                />}


                                        </Grid> */}
                                        <Grid item lg={4} xs={12}>
                                            <TextField
                                                type="text"
                                                label={`Total Amount (${currencyCode})`}
                                                variant="outlined"
                                                fullWidth
                                                inputProps={{
                                                    pattern: "^[0-9.]+$",
                                                    maxLength: 30,
                                                    className: "custom-fieldtext"
                                                }}
                                                value={formatNumberWithCommas(values.totalAmount)}
                                                onChange={handleChange("totalAmount")} />
                                            {totalAmountErr ? <span style={errMsg}>Total Amount can't be blank</span> : ""}

                                        </Grid>
                                        <Grid item lg={4} xs={12}>
                                            <TextField
                                                type="text"
                                                label={`Tax Amount (${currencyCode})`}
                                                variant="outlined"
                                                fullWidth
                                                inputProps={{
                                                    pattern: "^[0-9.]+$",
                                                    maxLength: 30,
                                                    className: "custom-fieldtext"
                                                }}
                                                value={formatNumberWithCommas(values.taxAmount)}
                                                onChange={handleChange("taxAmount")}
                                            />
                                            {taxAmountErr ? <span style={errMsg}>Tax Amount can't be blank</span> : taxAmountErrMsg ? <span style={errMsg}>{taxAmountErrMsg}</span> : ""}
                                        </Grid>

                                        <Grid item lg={4} xs={12}>
                                            <label htmlFor="fileInput">
                                                <TextField
                                                    type="text"
                                                    label="Upload Document"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={fileName}
                                                    InputProps={{
                                                        readOnly: true,
                                                        className: "uploadfile",
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <label className="ress" htmlFor="fileInput">
                                                                    <Button

                                                                        component="span"
                                                                        size="small"
                                                                        allign="right"
                                                                        style={{ fontSize: "14px", marginTop: "4px", color: "#257BEA", marginLeft: "-19px", textDecoration: "2px solid underline" }}
                                                                    >
                                                                        Choose File
                                                                    </Button>


                                                                </label>
                                                                {/* {showEYEBtn ?
                              <IconButton style={{ marginLeft: "2px" }}>
                          <Visibility fontSize="medium" color="info" onClick={() => { setShowImageFlag(true); }} />
                           </IconButton>
                            :
                              <IconButton style={{ marginLeft: "2px" }}>
                            <VisibilityOff fontSize="medium" color="grey" />
                              </IconButton>} */}

                                                                <IconButton style={{ marginLeft: "2px" }}>
                                                                    {showEYEBtn ?
                                                                        <Visibility fontSize="medium" color="info" onClick={() => { setShowImageFlag(true); }} />
                                                                        :
                                                                        <VisibilityOff fontSize="medium" color="grey" />
                                                                    }
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                <input
                                                    type="file"
                                                    accept="image/*,.pdf,.docx,.doc,application/vnd.ms-excel"
                                                    // accept="image/*"
                                                    id="fileInput"
                                                    style={{ display: "none" }}
                                                    onChange={saveFile}
                                                />
                                            </label>
                                            {/* <TextField
                                                type="text"
                                                label={`Tip Amount (${currencyCode})`}
                                                variant="outlined"
                                                fullWidth
                                                inputProps={{
                                                    pattern: "^[0-9.]+$",
                                                    maxLength: 30
                                                }}
                                                value={values.tipAmount}
                                                onChange={handleChange("tipAmount")}
                                            /> */}
                                        </Grid>
                                        <Grid item lg={4} xs={12}>
                                            <TextField
                                                type="text"
                                                label={`Reference Number`}
                                                variant="outlined"
                                                fullWidth
                                                inputProps={{
                                                    // pattern: "^[0-9.]+$",
                                                    maxLength: 50,
                                                    className: "custom-fieldtext"
                                                }}
                                                value={values.referenceNumber}
                                                onChange={handleChange("referenceNumber")}
                                            />
                                            {/* {totalAmountErr ? <span style={errMsg}>Reference Number can't be blank</span> : ""} */}

                                        </Grid>
                                        <Grid item lg={8} xs={12}>
                                            <TextField
                                                type="text"
                                                label="Notes (Optional)"
                                                variant="outlined"
                                                fullWidth
                                                inputProps={{
                                                    maxLength: 100,
                                                    pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                                                }}
                                                value={values.notes}
                                                onChange={handleChange("notes")}
                                            />
                                        </Grid>

                                    </Grid>
                                </MDBox>
                                <Grid
                                    container
                                    pb={3}
                                    columnSpacing={4}
                                    alignItems="center"
                                    display="flex"
                                    justifyContent="center"
                                >
                                    <Grid item xs={12} md={4} spacing={2} lg={1.8}>
                                        {/* <Link to={"/expenses"}> */}
                                        <MDButton
                                            className="btn-block center-container-btn btn-warning btn-back rightSpace"
                                            color="warning"
                                            fullWidth
                                            onClick={handleCancel}
                                        >
                                            Close
                                        </MDButton>
                                        {/* </Link> */}
                                    </Grid>
                                    <Grid item xs={12} md={4} spacing={2} lg={1.8}>
                                        <MDButton
                                            rel="noreferrer"
                                            variant="gradient"
                                            color="success"
                                            fullWidth
                                            onClick={handleAddData}
                                            disabled={SCREEN_RIGHT === "View Only"}
                                        >
                                            {id ? "Update" : "Save"}
                                        </MDButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </MDBox>

                    {showImageFlag && <Modal
                        open={showImageFlag}
                        onClose={() => { setShowImageFlag(false) }}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                        sx={{
                            '& .MuiModal-root': {
                                width: '100%',
                                height: '100%',
                            },
                        }}
                    >
                        <Card
                            sx={darkMode ?
                                { ...pdfStyle, border: "none", width: { xs: "95%", sm: "90%", md: "80%" }, maxWidth: "1200px", background: "black" } :
                                { ...pdfStyle, border: "none", width: { xs: "95%", sm: "90%", md: "80%" }, maxWidth: "1200px" }
                            }
                        >
                            <Box>
                                <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    sx={{ fontSize: { xs: "1.5rem", sm: "1.75rem" } }}
                                >
                                    Document Viewer
                                </Typography>
                                <Box sx={{ width: "100%", height: { xs: "60vh", sm: "70vh", }, overflow: "hidden", }}>
                                    <iframe
                                        title=" Document Viewer"
                                        src={file}
                                        width="100%"
                                        height="650"
                                        style={{ display: 'block', objectFit: "contain", aspectRatio: "1/1" }}
                                    ></iframe>
                                </Box>
                                <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                                    <MDButton
                                        color="warning"
                                        className="modalButton"
                                        onClick={() => { setShowImageFlag(false) }}
                                        sx={{ fontSize: "1rem", padding: "0.5rem 1rem" }}
                                    >
                                        Close
                                    </MDButton>
                                </Grid>
                            </Box>
                        </Card>
                    </Modal>}
                </Card>

            </div>
            <LoadingModal loading={loading} />

        </DashboardLayout>
    );
}
export default AddExpenses;
